module.exports = __webpack_public_path__ + "img/logo.ffd22450.png";